<template>
  <div class="faturamento-page">

    <!-- ── SEÇÃO: Filtros ── -->
    <div class="form-section">
      <div class="form-section__header">
        <div class="form-section__icon-wrap">
          <v-icon color="#0052A0" size="20">mdi-filter-outline</v-icon>
        </div>
        <div>
          <div class="form-section__title">Filtros</div>
          <div class="form-section__sub">Busque faturas por período de emissão, vencimento ou status</div>
        </div>
      </div>
      <div class="form-section__body">
        <v-row dense align="end">
          <v-col cols="12" md="3">
            <data-component
              v-model="dataInicial"
              labelDate="Emissão Inicial"
              only-date outlined dense color="#0052A0" clearable
            />
          </v-col>
          <v-col cols="12" md="3">
            <data-component
              v-model="dataFinal"
              labelDate="Emissão Final"
              only-date outlined dense color="#0052A0" clearable
            />
          </v-col>
          <v-col cols="12" md="3">
            <data-component
              v-model="vencInicial"
              labelDate="Vencimento Inicial"
              only-date outlined dense color="#0052A0" clearable
            />
          </v-col>
          <v-col cols="12" md="3">
            <data-component
              v-model="vencFinal"
              labelDate="Vencimento Final"
              only-date outlined dense color="#0052A0" clearable
            />
          </v-col>
          <v-col cols="12" md="3">
            <v-select
              v-model="status_fatura"
              :items="dropdown_edit"
              item-text="text"
              item-value="value"
              label="Status Pagamento"
              outlined dense color="#0052A0"
              clearable
            />
          </v-col>
        </v-row>

        <div class="filter-actions">
          <v-btn color="#0052A0" rounded elevation="0" @click="getFaturas" class="px-5">
            <v-icon left color="#FFD400" small>mdi-magnify</v-icon>
            <span style="color:#FFD400;font-weight:700;font-size:13px">Buscar</span>
          </v-btn>
          <v-btn outlined rounded elevation="0" color="#0052A0" @click="limpar" class="px-5">
            <v-icon left small>mdi-close-circle-outline</v-icon>
            <span style="font-size:13px">Limpar</span>
          </v-btn>
        </div>
      </div>
    </div>

    <!-- ── SEÇÃO: Tabela ── -->
    <div class="form-section form-section--last">
      <v-data-table
        :headers="headers"
        :items="list"
        class="faturas-table elevation-0"
        no-data-text="Nenhuma fatura encontrada"
        :footer-props="{
          'items-per-page-text': 'Registros por página: ',
          'page-text': '{0}-{1} de {2}',
          'items-per-page-all-text': 'Listar todos',
        }"
      >
        <template v-slot:item="{ item }">
          <tr>
            <td class="cell-mono">{{ item.id }}</td>
            <td>{{ item.referencia }}</td>
            <td>{{ moment(item.data_faturamento).format('DD/MM/YYYY') }}</td>
            <td>{{ moment(item.data_vencimento).format('DD/MM/YYYY') }}</td>
            <td>
              <v-chip x-small label
                :color="item.status ? '#dcfce7' : '#fef2f2'"
                :text-color="item.status ? '#166534' : '#991b1b'"
                style="font-family:'Inter',sans-serif;font-weight:600;"
              >
                <v-icon x-small left>{{ item.status ? 'mdi-check-bold' : 'mdi-clock-outline' }}</v-icon>
                {{ item.status ? 'Pago' : 'Em aberto' }}
              </v-chip>
            </td>
            <td>{{ converterDinherio(item.valor_total) }}</td>
            <td>
              <v-btn icon small color="#0052A0"
                :to="{ name: 'Detalhes da Fatura', params: { id: item.id, name: empresaName } }"
                title="Ver detalhes"
              >
                <v-icon small>mdi-magnify</v-icon>
              </v-btn>
              <v-btn icon small color="#0052A0" @click="emitirFatura()" title="Imprimir fatura">
                <v-icon small>mdi-printer</v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
    </div>

    <img id="itf" style="visibility:collapse;" />
  </div>
</template>

<script>
import DataComponent from "../../components/DataComponent";
import helper from "../../mixins/helper";

export default {
  components: { DataComponent },
  mixins: [helper],
  data: () => ({
    list: [],
    search: "",
    dataInicial: null,
    dataFinal: null,
    vencInicial: null,
    vencFinal: null,
    status_fatura: null,
    dropdown_edit: [
      { text: 'Todos', value: 0 },
      { text: 'Abertos', value: 1 },
      { text: 'Pagos', value: 2 },
    ],
    headers: [
      { text: "Nº Fatura",       value: "id",               align: "start" },
      { text: "Referência",      value: "referencia",        align: "start" },
      { text: "Data Emissão",    value: "data_faturamento",  align: "start" },
      { text: "Data Vencimento", value: "data_vencimento",   align: "start" },
      { text: "Status",          value: "status",            align: "start" },
      { text: "Valor",           value: "valor_total",       align: "start" },
      { text: "Ações",           value: "",                  align: "center", sortable: false },
    ],
  }),
  computed: {
    empresaName() {
      const u = this.$store.state.auth.user;
      return u && u.domain ? u.domain.name : '';
    },
  },
  mounted() {
    this.getFaturas();
  },
  methods: {
    limpar() {
      this.dataInicial = null;
      this.dataFinal   = null;
      this.vencInicial = null;
      this.vencFinal   = null;
      this.status_fatura = null;
      this.list = [];
    },
    emitirFatura() {
      // implementação de impressão
    },
    notificacao(title, msg, icon) {
      this.$swal({
        toast: true,
        position: "center",
        showConfirmButton: false,
        timer: 3000,
        icon,
        title,
        text: msg,
      });
    },
    async getFaturas() {
      try {
        const { data: result } = await this.$http.get("faturas");
        this.list = result;
      } catch (error) {
        //
      }
    },
  },
};
</script>

<style scoped>
.faturamento-page {
  display: flex;
  flex-direction: column;
  background: #fff;
  min-height: calc(100vh - 64px);
  padding: 28px 32px;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}

.form-section {
  border-bottom: 1px solid #f1f5f9;
  padding-bottom: 32px;
  margin-bottom: 32px;
}
.form-section--last { border-bottom: none; padding-bottom: 0; margin-bottom: 0; }

.form-section__header {
  display: flex; align-items: flex-start; gap: 12px; padding: 0 0 18px 0;
}
.form-section__icon-wrap {
  width: 34px; height: 34px; background: #e8f0fe; border-radius: 8px;
  display: flex; align-items: center; justify-content: center; flex-shrink: 0;
}
.form-section__title { font-family: 'Inter', sans-serif; font-size: 0.92rem; font-weight: 700; color: #1e293b; }
.form-section__sub   { font-family: 'Inter', sans-serif; font-size: 0.78rem; color: #94a3b8; margin-top: 1px; }
.form-section__body  { padding: 0; }

.filter-actions { display: flex; flex-wrap: wrap; gap: 10px; margin-top: 8px; }
@media (max-width: 600px) {
  .filter-actions > .v-btn { flex: 1 1 auto; min-width: 0 !important; }
}

.faturas-table >>> th {
  font-family: 'Inter', sans-serif !important; font-size: 0.72rem !important;
  font-weight: 700 !important; color: #64748b !important;
  text-transform: uppercase; letter-spacing: 0.5px;
  background: #f8fafc !important; padding: 10px 12px !important;
  white-space: nowrap;
}
.faturas-table >>> td {
  font-family: 'Inter', sans-serif !important; font-size: 0.85rem !important;
  color: #1e293b !important; font-weight: 400 !important;
  padding: 10px 12px !important; border-bottom: 1px solid #f1f5f9 !important;
}
.cell-mono { font-size: 0.75rem !important; color: #64748b !important; }

.faturamento-page >>> .v-input__slot { background-color: #fff !important; box-shadow: none !important; }
.faturamento-page >>> .v-label { font-family: 'Inter', sans-serif !important; font-size: 0.85rem !important; }

@media (max-width: 768px) { .faturamento-page { padding: 16px; } }
</style>
